import { useHistory } from 'react-router'
import React, { useCallback } from 'react'

import Success from 'components/EditPost/Success'
import { JobBoardConfirm } from 'utils/text'
import {usePersistedState} from "../../../hooks";
import {entities} from "../../../reduxStore";


export default function EditJobPostSuccessPage() {
	const history = useHistory()
	const { repost } = history.location?.state as any
	const job: any = usePersistedState({
		entityName: entities.editedJobPost
	})[0]

	return (
		<Success
			header={JobBoardConfirm.JobBoardHeader}
			text={repost ? 'Your job is reposted and displayed for applicants.' : JobBoardConfirm.JobBoardText}
			buttonText={JobBoardConfirm.JobBoardButton}
			description
			practiceName={job.location.practiceName}
			onClose={useCallback(() => {
				history.replace('jobBoard')
			}, [history])}
			onBackToJobPostings={useCallback(() => {
				history.replace('jobBoard')
			}, [history])}
		/>
	)
}
